export class PaymentBasics {
    public allowPaymentAtLocation?: boolean;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): PaymentBasics {
        const paymentBasics: PaymentBasics = new PaymentBasics();

        paymentBasics.allowPaymentAtLocation = this.allowPaymentAtLocation;

        return paymentBasics;
    }
}
